var _style, _g, _g2, _path, _g3, _defs, _g4, _path2, _g5, _defs2, _g6, _path3, _g7, _defs3, _g8, _path4, _g9, _defs4, _g10, _path5, _g11, _defs5, _g12, _path6, _g13, _defs6, _g14, _path7, _g15, _defs7, _g16, _path8, _g17, _defs8, _g18, _g19, _g20;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoDigital(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Livello_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 336.8 57.7",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;fill:#0086FF;}\n\t.st2{display:inline;}\n\t.st3{fill:#000;}\n\t.st4{clip-path:url(#SVGID_10_);}\n\t.st5{clip-path:url(#SVGID_12_);}\n\t.st6{clip-path:url(#SVGID_14_);}\n\t.st7{clip-path:url(#SVGID_16_);}\n\t.st8{clip-path:url(#SVGID_18_);}\n\t.st9{clip-path:url(#SVGID_20_);}\n\t.st10{clip-path:url(#SVGID_22_);}\n\t.st11{clip-path:url(#SVGID_24_);}\n\t.st12{display:inline;fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -5.2,
    y: -10,
    className: "st1",
    width: 444.6,
    height: 72.8
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    className: "st0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M338.9,6.6c9.9,0,15.1,4.8,15.1,14.4c0,15.2-7.2,22.5-21.9,22.5h-9.8l6.1-36.8L338.9,6.6z M332.4,11    l-4.7,28.3h6c11.4,0,15.4-7.3,15.3-17.7c0-6.8-3.2-10.6-10.7-10.6C338.3,11,332.4,11,332.4,11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M389.9,43.5l1.8-28.5l-14.5,28.5h-3.7L368.4,15l-7.5,28.5h-4.4l9.7-36.9h5.2l5.1,29.8l15.1-29.8h5.1    l-2.5,36.9H389.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M403,35.3c2.7,2.9,5.9,4.8,9.5,4.8c4.8,0,8.5-2.7,8.5-7.5c0-2.9-1.9-4.5-7.1-6.2c-6.4-2.1-9.1-4.6-9.1-9    c0-7.7,5.9-11.4,13.4-11.5c4.6,0,8.5,1.7,11,5.3l-3,2.9c-2-2.6-5.1-4.2-8.4-4.2c-4.8,0-8.1,2.2-8.1,6.2c0,3.6,2.7,4.8,7.8,6.6    c5.8,2.1,8.6,4.5,8.6,9.3c0,7.2-5.8,12-13.9,12.1c-4.7,0.2-9.3-1.9-12.2-5.7L403,35.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M73.4,6.8h23.8l-1,6.1h-17l-1.5,8.9h15.4l-1,6.2H76.7l-1.6,9.4h17.3l-1,6H67.3L73.4,6.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M107.7,16.5l-0.1,3.6c2.4-2.5,5.7-4.1,9.2-4.2c5.5,0,7.7,3.6,6.8,9.5l-3,18.1H114l2.7-16    c0.7-4-0.4-5.8-3.2-5.8c-2.6,0-5,2-6,3l-3.1,18.8h-6.6l4.4-27H107.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M139,21.6l-2.6,15.1c-0.2,1.6,0.2,2.2,1.3,2.2s2.1-0.2,3.2-0.5l-0.1,4.7c-2,0.6-4.2,1-6.3,1    c-3.9,0-5.5-2.2-4.8-6l2.7-16.5h-3.5l0.7-3.9l3.7-1.1l2-7.8h5.8l-1.3,7.7h4.8l-0.8,5.1C143.8,21.6,139,21.6,139,21.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M168.8,40.6c-3.4,2.3-7.3,3.5-11.4,3.5c-6.8,0-10.7-4.2-10.7-11.2c0-10.2,6.4-17,15.4-17    c6.1,0,9.4,3.4,9.4,8.1c0,8.8-8.6,9-17.9,9.6c0,2.5,1.5,5,5.5,4.9c2.8,0,5.5-0.8,7.9-2.2L168.8,40.6z M165.1,24    c0-1.8-1.2-3.1-3.4-3.1c-4.5,0-7.2,3.9-7.9,7.8C160.9,28.3,165.1,27.8,165.1,24L165.1,24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M184,20.3c1.7-2.5,4.1-4.5,6.5-4.5c0.9,0,1.7,0.2,2.6,0.6l-1.6,6.2c-0.8-0.2-1.6-0.4-2.4-0.3    c-2,0-4.1,1.8-5.2,3.3l-3,17.9h-6.6l4.4-27h5.3V20.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M191.6,53.6l6.1-37.2h5.5l0.1,3.5c2.8-2.7,5.8-4.2,9.2-4.2c5.3,0,8.6,3.7,8.6,10.6c0,10-4.7,17.6-13.8,17.6    c-2.8,0.1-5.4-1.1-7.1-3.3l-2.1,12.9L191.6,53.6z M201.2,35.4c1.2,1.8,3.2,2.9,5.4,2.9c4.4,0,7.4-3.7,7.3-10.8c0-3.9-1.4-6-4.4-6    c-2.6,0-5.1,1.8-6.6,3.4L201.2,35.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M234.5,20.2c1.7-2.5,4.1-4.5,6.5-4.5c0.9,0,1.8,0.2,2.6,0.5l-1.6,6.2c-0.8-0.2-1.6-0.4-2.4-0.3    c-2,0-4.1,1.8-5.2,3.3l-3,17.9h-6.6l4.4-27h5.3V20.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M250.7,43.3h-6.6l4.5-27h6.6L250.7,43.3z M253.7,5.9c2.1,0,3.5,1,3.5,3c0,2.5-2,4-4.6,4    c-1.9,0-3.4-1.1-3.4-2.9C249.1,7.3,251.3,5.9,253.7,5.9L253.7,5.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M260.2,35.3c2.2,2,5,3.2,8,3.3c2.7,0,4-1.3,4-3.1c0-2.2-2-2.7-4.8-3.5c-4.3-1.3-7-3.1-7.1-7.3    c0-5.9,4.9-9,11.3-9c4.4,0,7.6,1.4,9.9,3.9l-3.5,4c-1.9-1.6-4.3-2.6-6.8-2.8c-2,0-4,0.6-4,2.7c0,1.6,1,2.2,4.9,3.5    s7.4,2.8,7.4,7.7c0,6.2-5.2,9.3-11.6,9.4c-4.2,0-8.2-1.6-11.2-4.5L260.2,35.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M306.5,40.3c-3.4,2.3-7.3,3.5-11.4,3.5c-6.8,0-10.7-4.2-10.7-11.2c0-10.2,6.4-17,15.4-17    c6.1,0,9.4,3.4,9.4,8.1c0,8.8-8.6,8.9-17.9,9.6c0,2.5,1.5,5,5.5,4.9c2.8,0,5.5-0.8,7.9-2.2L306.5,40.3z M302.8,23.8    c0-1.8-1.2-3.1-3.4-3.1c-4.5,0-7.2,4-7.9,7.8C298.6,28.1,302.9,27.6,302.8,23.8z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M73.3,7h6.8l-6,36.4h-6.8L73.3,7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M91.6,16.7v3.5c2.2-2.2,5.5-4.2,9.1-4.2c5.5,0,7.6,3.6,6.7,9.4l-3,17.9h-6.6l2.7-15.9c0.7-4-0.4-5.7-3.2-5.7    c-2.6,0-5,2-5.9,3l-3.1,18.6h-6.6l4.4-26.7L91.6,16.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M129.8,39.9c-1.6,1.9-4.6,4.1-8.7,4.1c-6,0-8.8-4.5-8.8-10.9c0-11,6.2-17.1,13.3-17.1c3.7,0,5.8,1.6,7.3,3.5    L135,6.9h6.5l-6,36.4h-5.8L129.8,39.9z M131.9,24.8c-0.8-1.2-2.4-3-5.2-3c-4.4,0-7.4,3.9-7.4,10.5c0,3.4,0.8,6.1,4.3,6.1    c2.7,0,5.3-1.7,6.5-3L131.9,24.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M159.5,43.3v-3.5c-2.3,2.2-4.9,4.2-8.7,4.2c-6.1,0-7.8-4.1-6.9-9.7l2.9-17.7h6.6l-2.7,16.5    c-0.6,3.5,0,5.2,2.9,5.2c2.4,0,4.5-1.4,6-2.9l3.1-18.8h6.6l-4.4,26.7H159.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M174,35.4c2.2,1.9,5.2,3.3,7.9,3.3s3.9-1.3,3.9-3.1c0-2.2-2-2.7-4.7-3.5c-4.3-1.3-7-3.1-7-7.2    c0-5.8,4.8-8.9,11.2-8.9c4.3,0,7.5,1.4,9.8,3.8l-3.5,4c-2.2-1.7-4.5-2.7-6.7-2.7c-2,0-4,0.6-4,2.6c0,1.6,1,2.2,4.8,3.4    c3.9,1.3,7.3,2.8,7.3,7.6c0,6.1-5.2,9.3-11.5,9.3c-4.6,0-8.9-2-11.1-4.4L174,35.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M208.3,21.6l-2.5,15c-0.2,1.6,0.2,2.2,1.3,2.2c0.8,0,2.4-0.2,3.1-0.5l-0.1,4.6c-1.9,0.6-4.3,1-6.3,1    c-3.9,0-5.4-2.2-4.8-6l2.7-16.3h-3.4l0.6-3.9l3.7-1.1l2-7.7h5.7l-1.3,7.6h4.7l-0.8,5.1L208.3,21.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M224.9,20.3c1.7-2.5,4.1-4.5,6.5-4.5c1,0,1.9,0.2,2.5,0.6l-1.6,6.1c-0.8-0.3-1.5-0.4-2.4-0.3    c-2,0-4.1,1.8-5.2,3.3l-3,17.7h-6.6l4.4-26.7h5.3L224.9,20.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M260.1,16.4l-13,25.7c-3.9,7.7-5.7,11.3-12.6,11.4c-1.4,0-2.9-0.2-4.3-0.6l1.3-4.8c0.8,0.2,1.9,0.4,3.2,0.3    c1.9,0,3.3-0.5,4.9-3.8l0.4-0.8l-4.5-27.5h6.8l2.1,19.7l8.9-19.7L260.1,16.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M286.5,35.3h-15.8l0.8-4.9l17.6-23.3h8.2l-3.8,22.8h3.9l-0.9,5.4h-3.9l-1.3,7.7h-6.2L286.5,35.3z M287.4,29.9    l2.8-16.8l-12.5,16.8H287.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M304,36.4c2.4,0,3.9,1.5,3.9,3.6c0,2.2-1.5,3.7-3.9,3.7c-2.5,0-3.8-1.5-3.8-3.5    C300.2,37.9,301.6,36.4,304,36.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M331.3,6.6c6.7,0,10.1,4.6,10.1,12.7c0,1.7-0.1,3.6-0.4,5.6c-1.9,13.4-7.6,18.8-15.7,18.8    c-6.7,0-10.2-4.3-10.2-12.7c0-1.8,0.1-3.6,0.4-5.8C317.4,12.4,323.2,6.6,331.3,6.6z M321.6,31c0,5,1.5,7,4.6,7    c4.1,0,6.9-4.3,8.3-12.9c0.4-2.2,0.5-4.1,0.5-5.8c0-4.7-1.5-7.1-4.6-7.1c-4.2,0-6.9,4.5-8.3,12.9C321.7,27.2,321.6,29.3,321.6,31z    "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M387.5,42.9l1.8-28.1L375,42.9h-3.7l-5-28.1l-7.4,28.1h-4.3l9.5-36.4h5.2l5,29.4l14.9-29.4h5.1l-2.5,36.4    H387.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M405.5,6.4h22.6l-0.7,4.2h-18l-1.9,11.5h16.3l-0.7,4.3h-16.3l-2,12.2h18.3l-0.7,4.2h-22.9L405.5,6.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M431.3,34.8c2.7,2.9,5.8,4.7,9.4,4.7c4.8,0,8.4-2.6,8.4-7.4c0-2.8-1.8-4.4-7-6.1c-6.3-2.1-9-4.6-9-8.9    c0-7.6,5.8-11.3,13.2-11.3c4.6,0,8.4,1.7,10.9,5.2l-3,2.9c-2.1-2.8-5.2-4.1-8.2-4.1c-4.7,0-8,2.2-8,6.1c0,3.6,2.7,4.7,7.7,6.5    c5.8,2.1,8.5,4.4,8.5,9.2c0,7.1-5.7,11.9-13.7,11.9c-5.2,0-9.6-2.2-12-5.6L431.3,34.8z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "TS",
    className: "st0"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1.9,40.8c0.2,0.4,0.4,0.8,0.7,1.1c0.3,0.4,0.5,0.7,0.5,0.7c3,3.5,7.2,5.8,11.7,6.4c0,0,9.6-2.2,12.7-8.1   c-0.9,0.1-1.7,0.2-2.6,0.2c-3.2,0.4-6.3-1.7-7.1-4.8l-0.1-0.6c0-0.3-0.1-0.7-0.2-1c-0.2-1.2-0.2-2.3-0.2-3.5V15H22V6.4h-4.8V0h-3.3   C4.7,0,0,3.5,0,11.2v21.6c0,2.8,0.6,5.5,2,7.9L1.9,40.8z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M1.9,40.8c0.2,0.4,0.4,0.8,0.7,1.1c0.3,0.4,0.5,0.7,0.5,0.7c3,3.5,7.2,5.8,11.7,6.4c0,0,9.6-2.2,12.7-8.1     c-0.9,0.1-1.7,0.2-2.6,0.2c-3.2,0.4-6.3-1.7-7.1-4.8l-0.1-0.6c0-0.3-0.1-0.7-0.2-1c-0.2-1.2-0.2-2.3-0.2-3.5V15H22V6.4h-4.8V0     h-3.3C4.7,0,0,3.5,0,11.2v21.6c0,2.8,0.6,5.5,2,7.9L1.9,40.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_9_",
    d: "M1.9,40.8c0.2,0.4,0.4,0.8,0.7,1.1c0.3,0.4,0.5,0.7,0.5,0.7c3,3.5,7.2,5.8,11.7,6.4        c0,0,9.6-2.2,12.7-8.1c-0.9,0.1-1.7,0.2-2.6,0.2c-3.2,0.4-6.3-1.7-7.1-4.8l-0.1-0.6c0-0.3-0.1-0.7-0.2-1        c-0.2-1.2-0.2-2.3-0.2-3.5V15H22V6.4h-4.8V0h-3.3C4.7,0,0,3.5,0,11.2v21.6c0,2.8,0.6,5.5,2,7.9L1.9,40.8z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_9_",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_9_",
    style: {
      overflow: "visible"
    }
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -12.9,
    y: -12.9,
    width: 53.4,
    height: 74.8
  }))))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M20.7,49l0.2,0.6h5.5c7,0,15-1.6,19.2-6.2c0.2-0.3,0.5-0.5,0.7-0.8c0.2-0.2,0.3-0.4,0.4-0.6   c1.2-1.9,1.8-4.1,1.8-6.4c-0.2-2.9-0.6-5.8-1.2-8.6l-0.1-0.7v-0.6c-0.5-2.6-1-4.6-1-5.2c-0.1-0.7-0.1-1.4,0-2.1c0-0.2,0-0.3,0-0.5   c0.6-2.2,2.6-2.8,5.2-2.8V6.6h-11c-4.2-0.3-8.1,1.8-10.2,5.5L30,12.4v0.1l-0.3,0.7c-0.1,0.4-0.3,0.9-0.4,1.3   c-0.3,1.6-0.3,3.2,0,4.8c0.8,3.6,1.6,6.4,2.1,9.3c0.5,2.4,0.7,4.8,0.7,7.2c0,0.9-0.1,1.7-0.3,2.6C30.8,42.9,27.2,46.6,20.7,49z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_3_",
    d: "M20.7,49l0.2,0.6h5.5c7,0,15-1.6,19.2-6.2c0.2-0.3,0.5-0.5,0.7-0.8c0.2-0.2,0.3-0.4,0.4-0.6     c1.2-1.9,1.8-4.1,1.8-6.4c-0.2-2.9-0.6-5.8-1.2-8.6l-0.1-0.7v-0.6c-0.5-2.6-1-4.6-1-5.2c-0.1-0.7-0.1-1.4,0-2.1     c0-0.2,0-0.3,0-0.5c0.6-2.2,2.6-2.8,5.2-2.8V6.6h-11c-4.2-0.3-8.1,1.8-10.2,5.5L30,12.4v0.1l-0.3,0.7c-0.1,0.4-0.3,0.9-0.4,1.3     c-0.3,1.6-0.3,3.2,0,4.8c0.8,3.6,1.6,6.4,2.1,9.3c0.5,2.4,0.7,4.8,0.7,7.2c0,0.9-0.1,1.7-0.3,2.6C30.8,42.9,27.2,46.6,20.7,49z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_11_",
    d: "M20.7,49l0.2,0.6h5.5c7,0,15-1.6,19.2-6.2c0.2-0.3,0.5-0.5,0.7-0.8c0.2-0.2,0.3-0.4,0.4-0.6        c1.2-1.9,1.8-4.1,1.8-6.4c-0.2-2.9-0.6-5.8-1.2-8.6l-0.1-0.7v-0.6c-0.5-2.6-1-4.6-1-5.2c-0.1-0.7-0.1-1.4,0-2.1        c0-0.2,0-0.3,0-0.5c0.6-2.2,2.6-2.8,5.2-2.8V6.6h-11c-4.2-0.3-8.1,1.8-10.2,5.5L30,12.4v0.1l-0.3,0.7        c-0.1,0.4-0.3,0.9-0.4,1.3c-0.3,1.6-0.3,3.2,0,4.8c0.8,3.6,1.6,6.4,2.1,9.3c0.5,2.4,0.7,4.8,0.7,7.2c0,0.9-0.1,1.7-0.3,2.6        C30.8,42.9,27.2,46.6,20.7,49z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_11_",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_12_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_11_",
    style: {
      overflow: "visible"
    }
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.7,
    y: -6.4,
    width: 56.3,
    height: 68.9
  }))))))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M2,40.8c0.2,0.4,0.4,0.8,0.7,1.1c0.3,0.4,0.5,0.7,0.5,0.7c3,3.5,7.2,5.8,11.7,6.4c0,0,9.6-2.2,12.7-8.1   c-0.9,0.1-1.7,0.2-2.6,0.2c-3.2,0.4-6.3-1.7-7.1-4.8l-0.2-0.5c0-0.3-0.1-0.7-0.2-1c-0.2-1.2-0.2-2.4-0.2-3.6V15H22V6.4h-4.8V0h-3.3   C4.7,0,0,3.5,0,11.2v21.6C0,35.6,0.6,38.3,2,40.8L2,40.8z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_5_",
    d: "M2,40.8c0.2,0.4,0.4,0.8,0.7,1.1c0.3,0.4,0.5,0.7,0.5,0.7c3,3.5,7.2,5.8,11.7,6.4c0,0,9.6-2.2,12.7-8.1     c-0.9,0.1-1.7,0.2-2.6,0.2c-3.2,0.4-6.3-1.7-7.1-4.8l-0.2-0.5c0-0.3-0.1-0.7-0.2-1c-0.2-1.2-0.2-2.4-0.2-3.6V15H22V6.4h-4.8V0     h-3.3C4.7,0,0,3.5,0,11.2v21.6C0,35.6,0.6,38.3,2,40.8L2,40.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_13_",
    d: "M2,40.8c0.2,0.4,0.4,0.8,0.7,1.1c0.3,0.4,0.5,0.7,0.5,0.7c3,3.5,7.2,5.8,11.7,6.4        c0,0,9.6-2.2,12.7-8.1c-0.9,0.1-1.7,0.2-2.6,0.2c-3.2,0.4-6.3-1.7-7.1-4.8l-0.2-0.5c0-0.3-0.1-0.7-0.2-1        c-0.2-1.2-0.2-2.4-0.2-3.6V15H22V6.4h-4.8V0h-3.3C4.7,0,0,3.5,0,11.2v21.6C0,35.6,0.6,38.3,2,40.8L2,40.8z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_13_",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_14_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_13_",
    style: {
      overflow: "visible"
    }
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -12.8,
    y: -12.9,
    width: 53.4,
    height: 74.8
  }))))))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M20.8,49l0.2,0.6h5.4c7,0,15-1.6,19.2-6.2c0.2-0.3,0.5-0.5,0.7-0.8c0.2-0.2,0.3-0.4,0.4-0.6   c1.2-1.9,1.8-4.1,1.7-6.4c-0.2-2.9-0.6-5.8-1.2-8.6l-0.1-0.7v-0.6c-0.5-2.6-1-4.6-1-5.2c-0.1-0.7-0.1-1.4,0-2.1c0-0.2,0-0.3,0-0.5   c0.6-2.2,2.6-2.8,5.2-2.8V6.6h-11c-4.2-0.3-8.1,1.8-10.2,5.5l-0.2,0.3v0.1l-0.3,0.7c-0.1,0.4-0.3,0.9-0.4,1.3   c-0.3,1.6-0.3,3.2,0,4.8c0.8,3.6,1.6,6.4,2.1,9.3c0.5,2.4,0.7,4.8,0.7,7.2c0,0.9-0.1,1.7-0.3,2.6C30.9,42.9,27.3,46.6,20.8,49z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_7_",
    d: "M20.8,49l0.2,0.6h5.4c7,0,15-1.6,19.2-6.2c0.2-0.3,0.5-0.5,0.7-0.8c0.2-0.2,0.3-0.4,0.4-0.6     c1.2-1.9,1.8-4.1,1.7-6.4c-0.2-2.9-0.6-5.8-1.2-8.6l-0.1-0.7v-0.6c-0.5-2.6-1-4.6-1-5.2c-0.1-0.7-0.1-1.4,0-2.1     c0-0.2,0-0.3,0-0.5c0.6-2.2,2.6-2.8,5.2-2.8V6.6h-11c-4.2-0.3-8.1,1.8-10.2,5.5l-0.2,0.3v0.1l-0.3,0.7c-0.1,0.4-0.3,0.9-0.4,1.3     c-0.3,1.6-0.3,3.2,0,4.8c0.8,3.6,1.6,6.4,2.1,9.3c0.5,2.4,0.7,4.8,0.7,7.2c0,0.9-0.1,1.7-0.3,2.6C30.9,42.9,27.3,46.6,20.8,49z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_15_",
    d: "M20.8,49l0.2,0.6h5.4c7,0,15-1.6,19.2-6.2c0.2-0.3,0.5-0.5,0.7-0.8c0.2-0.2,0.3-0.4,0.4-0.6        c1.2-1.9,1.8-4.1,1.7-6.4c-0.2-2.9-0.6-5.8-1.2-8.6l-0.1-0.7v-0.6c-0.5-2.6-1-4.6-1-5.2c-0.1-0.7-0.1-1.4,0-2.1        c0-0.2,0-0.3,0-0.5c0.6-2.2,2.6-2.8,5.2-2.8V6.6h-11c-4.2-0.3-8.1,1.8-10.2,5.5l-0.2,0.3v0.1l-0.3,0.7        c-0.1,0.4-0.3,0.9-0.4,1.3c-0.3,1.6-0.3,3.2,0,4.8c0.8,3.6,1.6,6.4,2.1,9.3c0.5,2.4,0.7,4.8,0.7,7.2c0,0.9-0.1,1.7-0.3,2.6        C30.9,42.9,27.3,46.6,20.8,49z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_15_",
    style: {
      overflow: "visible"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_16_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_15_",
    style: {
      overflow: "visible"
    }
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    className: "st7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.9,
    y: -6.4,
    width: 56.3,
    height: 68.9
  })))))))), /*#__PURE__*/React.createElement("g", {
    id: "TS_1_"
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M1.9,40.8c0.2,0.4,0.4,0.8,0.7,1.1c0.3,0.4,0.5,0.7,0.5,0.7c3,3.5,7.2,5.8,11.7,6.4c0,0,9.6-2.2,12.7-8.1   c-0.9,0.1-1.7,0.2-2.6,0.2c-3.2,0.4-6.3-1.7-7.1-4.8l-0.1-0.6c0-0.3-0.1-0.7-0.2-1c-0.2-1.2-0.2-2.3-0.2-3.5V15H22V6.4h-4.8V0h-3.3   C4.7,0,0,3.5,0,11.2v21.6c0,2.8,0.6,5.5,2,7.9L1.9,40.8z"
  })), /*#__PURE__*/React.createElement("g", null, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_8_",
    className: "st3",
    d: "M1.9,40.8c0.2,0.4,0.4,0.8,0.7,1.1c0.3,0.4,0.5,0.7,0.5,0.7c3,3.5,7.2,5.8,11.7,6.4     c0,0,9.6-2.2,12.7-8.1c-0.9,0.1-1.7,0.2-2.6,0.2c-3.2,0.4-6.3-1.7-7.1-4.8l-0.1-0.6c0-0.3-0.1-0.7-0.2-1     c-0.2-1.2-0.2-2.3-0.2-3.5V15H22V6.4h-4.8V0h-3.3C4.7,0,0,3.5,0,11.2v21.6c0,2.8,0.6,5.5,2,7.9L1.9,40.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_17_",
    d: "M1.9,40.8c0.2,0.4,0.4,0.8,0.7,1.1c0.3,0.4,0.5,0.7,0.5,0.7c3,3.5,7.2,5.8,11.7,6.4        c0,0,9.6-2.2,12.7-8.1c-0.9,0.1-1.7,0.2-2.6,0.2c-3.2,0.4-6.3-1.7-7.1-4.8l-0.1-0.6c0-0.3-0.1-0.7-0.2-1        c-0.2-1.2-0.2-2.3-0.2-3.5V15H22V6.4h-4.8V0h-3.3C4.7,0,0,3.5,0,11.2v21.6c0,2.8,0.6,5.5,2,7.9L1.9,40.8z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_17_",
    style: {
      overflow: "visible",
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_18_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_17_",
    style: {
      overflow: "visible"
    }
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -12.9,
    y: -12.9,
    className: "st3",
    width: 53.4,
    height: 74.8
  }))))))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M20.7,49l0.2,0.6h5.5c7,0,15-1.6,19.2-6.2c0.2-0.3,0.5-0.5,0.7-0.8c0.2-0.2,0.3-0.4,0.4-0.6   c1.2-1.9,1.8-4.1,1.8-6.4c-0.2-2.9-0.6-5.8-1.2-8.6l-0.1-0.7v-0.6c-0.5-2.6-1-4.6-1-5.2c-0.1-0.7-0.1-1.4,0-2.1c0-0.2,0-0.3,0-0.5   c0.6-2.2,2.6-2.8,5.2-2.8V6.6h-11c-4.2-0.3-8.1,1.8-10.2,5.5L30,12.4v0.1l-0.3,0.7c-0.1,0.4-0.3,0.9-0.4,1.3   c-0.3,1.6-0.3,3.2,0,4.8c0.8,3.6,1.6,6.4,2.1,9.3c0.5,2.4,0.7,4.8,0.7,7.2c0,0.9-0.1,1.7-0.3,2.6C30.8,42.9,27.2,46.6,20.7,49z"
  })), /*#__PURE__*/React.createElement("g", null, _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_6_",
    className: "st3",
    d: "M20.7,49l0.2,0.6h5.5c7,0,15-1.6,19.2-6.2c0.2-0.3,0.5-0.5,0.7-0.8c0.2-0.2,0.3-0.4,0.4-0.6     c1.2-1.9,1.8-4.1,1.8-6.4c-0.2-2.9-0.6-5.8-1.2-8.6l-0.1-0.7v-0.6c-0.5-2.6-1-4.6-1-5.2c-0.1-0.7-0.1-1.4,0-2.1     c0-0.2,0-0.3,0-0.5c0.6-2.2,2.6-2.8,5.2-2.8V6.6h-11c-4.2-0.3-8.1,1.8-10.2,5.5L30,12.4v0.1l-0.3,0.7c-0.1,0.4-0.3,0.9-0.4,1.3     c-0.3,1.6-0.3,3.2,0,4.8c0.8,3.6,1.6,6.4,2.1,9.3c0.5,2.4,0.7,4.8,0.7,7.2c0,0.9-0.1,1.7-0.3,2.6C30.8,42.9,27.2,46.6,20.7,49z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_19_",
    d: "M20.7,49l0.2,0.6h5.5c7,0,15-1.6,19.2-6.2c0.2-0.3,0.5-0.5,0.7-0.8c0.2-0.2,0.3-0.4,0.4-0.6        c1.2-1.9,1.8-4.1,1.8-6.4c-0.2-2.9-0.6-5.8-1.2-8.6l-0.1-0.7v-0.6c-0.5-2.6-1-4.6-1-5.2c-0.1-0.7-0.1-1.4,0-2.1        c0-0.2,0-0.3,0-0.5c0.6-2.2,2.6-2.8,5.2-2.8V6.6h-11c-4.2-0.3-8.1,1.8-10.2,5.5L30,12.4v0.1l-0.3,0.7        c-0.1,0.4-0.3,0.9-0.4,1.3c-0.3,1.6-0.3,3.2,0,4.8c0.8,3.6,1.6,6.4,2.1,9.3c0.5,2.4,0.7,4.8,0.7,7.2c0,0.9-0.1,1.7-0.3,2.6        C30.8,42.9,27.2,46.6,20.7,49z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_19_",
    style: {
      overflow: "visible",
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_20_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_19_",
    style: {
      overflow: "visible"
    }
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    className: "st9"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.7,
    y: -6.4,
    className: "st3",
    width: 56.3,
    height: 68.9
  }))))))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M2,40.8c0.2,0.4,0.4,0.8,0.7,1.1c0.3,0.4,0.5,0.7,0.5,0.7c3,3.5,7.2,5.8,11.7,6.4c0,0,9.6-2.2,12.7-8.1   c-0.9,0.1-1.7,0.2-2.6,0.2c-3.2,0.4-6.3-1.7-7.1-4.8l-0.2-0.5c0-0.3-0.1-0.7-0.2-1c-0.2-1.2-0.2-2.4-0.2-3.6V15H22V6.4h-4.8V0h-3.3   C4.7,0,0,3.5,0,11.2v21.6C0,35.6,0.6,38.3,2,40.8L2,40.8z"
  })), /*#__PURE__*/React.createElement("g", null, _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_4_",
    className: "st3",
    d: "M2,40.8c0.2,0.4,0.4,0.8,0.7,1.1c0.3,0.4,0.5,0.7,0.5,0.7c3,3.5,7.2,5.8,11.7,6.4     c0,0,9.6-2.2,12.7-8.1c-0.9,0.1-1.7,0.2-2.6,0.2c-3.2,0.4-6.3-1.7-7.1-4.8l-0.2-0.5c0-0.3-0.1-0.7-0.2-1     c-0.2-1.2-0.2-2.4-0.2-3.6V15H22V6.4h-4.8V0h-3.3C4.7,0,0,3.5,0,11.2v21.6C0,35.6,0.6,38.3,2,40.8L2,40.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_21_",
    d: "M2,40.8c0.2,0.4,0.4,0.8,0.7,1.1c0.3,0.4,0.5,0.7,0.5,0.7c3,3.5,7.2,5.8,11.7,6.4        c0,0,9.6-2.2,12.7-8.1c-0.9,0.1-1.7,0.2-2.6,0.2c-3.2,0.4-6.3-1.7-7.1-4.8l-0.2-0.5c0-0.3-0.1-0.7-0.2-1        c-0.2-1.2-0.2-2.4-0.2-3.6V15H22V6.4h-4.8V0h-3.3C4.7,0,0,3.5,0,11.2v21.6C0,35.6,0.6,38.3,2,40.8L2,40.8z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_21_",
    style: {
      overflow: "visible",
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_22_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_21_",
    style: {
      overflow: "visible"
    }
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    className: "st10"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -12.8,
    y: -12.9,
    className: "st3",
    width: 53.4,
    height: 74.8
  }))))))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M20.8,49l0.2,0.6h5.4c7,0,15-1.6,19.2-6.2c0.2-0.3,0.5-0.5,0.7-0.8c0.2-0.2,0.3-0.4,0.4-0.6   c1.2-1.9,1.8-4.1,1.7-6.4c-0.2-2.9-0.6-5.8-1.2-8.6l-0.1-0.7v-0.6c-0.5-2.6-1-4.6-1-5.2c-0.1-0.7-0.1-1.4,0-2.1c0-0.2,0-0.3,0-0.5   c0.6-2.2,2.6-2.8,5.2-2.8V6.6h-11c-4.2-0.3-8.1,1.8-10.2,5.5l-0.2,0.3v0.1l-0.3,0.7c-0.1,0.4-0.3,0.9-0.4,1.3   c-0.3,1.6-0.3,3.2,0,4.8c0.8,3.6,1.6,6.4,2.1,9.3c0.5,2.4,0.7,4.8,0.7,7.2c0,0.9-0.1,1.7-0.3,2.6C30.9,42.9,27.3,46.6,20.8,49z"
  })), /*#__PURE__*/React.createElement("g", null, _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_2_",
    className: "st3",
    d: "M20.8,49l0.2,0.6h5.4c7,0,15-1.6,19.2-6.2c0.2-0.3,0.5-0.5,0.7-0.8c0.2-0.2,0.3-0.4,0.4-0.6     c1.2-1.9,1.8-4.1,1.7-6.4c-0.2-2.9-0.6-5.8-1.2-8.6l-0.1-0.7v-0.6c-0.5-2.6-1-4.6-1-5.2c-0.1-0.7-0.1-1.4,0-2.1     c0-0.2,0-0.3,0-0.5c0.6-2.2,2.6-2.8,5.2-2.8V6.6h-11c-4.2-0.3-8.1,1.8-10.2,5.5l-0.2,0.3v0.1l-0.3,0.7c-0.1,0.4-0.3,0.9-0.4,1.3     c-0.3,1.6-0.3,3.2,0,4.8c0.8,3.6,1.6,6.4,2.1,9.3c0.5,2.4,0.7,4.8,0.7,7.2c0,0.9-0.1,1.7-0.3,2.6C30.9,42.9,27.3,46.6,20.8,49z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_23_",
    d: "M20.8,49l0.2,0.6h5.4c7,0,15-1.6,19.2-6.2c0.2-0.3,0.5-0.5,0.7-0.8c0.2-0.2,0.3-0.4,0.4-0.6        c1.2-1.9,1.8-4.1,1.7-6.4c-0.2-2.9-0.6-5.8-1.2-8.6l-0.1-0.7v-0.6c-0.5-2.6-1-4.6-1-5.2c-0.1-0.7-0.1-1.4,0-2.1        c0-0.2,0-0.3,0-0.5c0.6-2.2,2.6-2.8,5.2-2.8V6.6h-11c-4.2-0.3-8.1,1.8-10.2,5.5l-0.2,0.3v0.1l-0.3,0.7        c-0.1,0.4-0.3,0.9-0.4,1.3c-0.3,1.6-0.3,3.2,0,4.8c0.8,3.6,1.6,6.4,2.1,9.3c0.5,2.4,0.7,4.8,0.7,7.2c0,0.9-0.1,1.7-0.3,2.6        C30.9,42.9,27.3,46.6,20.8,49z"
  }))), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_23_",
    style: {
      overflow: "visible",
      fill: "rgb(255, 255, 255)"
    }
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_24_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_23_",
    style: {
      overflow: "visible"
    }
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    className: "st11"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7.9,
    y: -6.4,
    className: "st3",
    width: 56.3,
    height: 68.9
  })))))))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Easy_Lex",
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M72.8,6.8h24.1l-1,6.2H78.8l-1.5,9h15.6l-1,6.3H76.3l-1.6,9.5h17.4l-1,6.1H66.7L72.8,6.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M115.9,40.3c-1.6,1.9-4.7,4.2-8.9,4.2c-6.1,0-8.9-4.1-8.9-11c0-10.9,6.3-17.5,13.9-17.5   c3.4,0,5.9,1.2,7.6,4.1l1-3.5h5.5l-4.5,27.2h-5.9L115.9,40.3z M118.1,24.9c-0.8-1.2-2.5-3.1-5.3-3.1c-4.5,0-7.5,3.9-7.5,10.7   c0,3.5,0.8,6.2,4.4,6.2c2.7,0,5.4-1.8,6.6-3.1L118.1,24.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M131,35.7c2.2,1.9,5.3,3.3,8,3.3s4-1.3,4-3.2c0-2.3-2.1-2.7-4.8-3.5c-4.4-1.3-7.1-3.1-7.1-7.4   c0-5.9,4.9-9.1,11.4-9.1c4.4,0,7.7,1.4,10,3.9l-3.5,4c-2.2-1.8-4.6-2.8-6.9-2.8c-2,0-4.1,0.6-4.1,2.7c0,1.6,1,2.3,4.9,3.5   c4,1.3,7.4,2.8,7.4,7.7c0,6.2-5.3,9.4-11.7,9.4c-4.7,0-9-2-11.3-4.5L131,35.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M181.3,16.5l-13.2,26.1c-4,7.8-5.8,11.5-12.8,11.6c-1.4,0-2.9-0.2-4.4-0.6l1.3-4.8c0.8,0.2,2,0.4,3.3,0.4   c1.9,0,3.3-0.5,4.9-3.8l0.4-0.8l-4.6-28h7l2.1,20.1l9-20.1L181.3,16.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M204,6.6l-5.4,32.8h16.5l-0.7,4.3h-21.2l6.1-37.1L204,6.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M241.7,40.6c-3.4,2.5-7.2,3.6-10.8,3.6c-6.4,0-10.2-3.6-10.2-10.8c0-10.2,6.2-17.4,14.9-17.4   c5.7,0,8.4,3.3,8.4,7.5c0,6.2-4.5,9.4-18.8,10.1c0,2.9,1.2,6.9,6.8,6.9c2.8,0,5.4-0.9,8.3-2.8L241.7,40.6z M239.5,23.4   c0-2.3-1.6-3.7-4.6-3.7c-5.3,0-8.9,4.7-9.6,10.3C237.9,29.3,239.5,26.6,239.5,23.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M256.3,29.9l-6.6-13.3h4.9l4.8,10.3l8.2-10.3h4.8L261.6,30l6.7,13.7h-4.8l-5-10.7l-8.6,10.7h-4.8L256.3,29.9z   "
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Digital_Box"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M85.1,6.7c10.4,0,15.6,5.5,15.6,14.7c0,15-7,22.9-22.8,23l-11,0l6.2-37.6L85.1,6.7z M79.1,13L75,38.2l5.1,0   c9.6,0,13.2-6.3,13.2-15.6c0-6-2.8-9.6-9.1-9.5L79.1,13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M111,44.3l-6.7,0l4.5-27.6l6.7,0L111,44.3z M114,6.1c2.1,0,3.6,1,3.6,3c0,2.6-2,4.1-4.7,4.1   c-2,0-3.5-1.1-3.5-3C109.3,7.5,111.6,6.1,114,6.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M143.4,43.4c-1.6,9.5-5.7,11.8-13.8,11.8c-4.3,0-7.8-0.9-10-1.8l1.7-5.1c2.2,0.7,4.7,1.4,7.9,1.4   c4.9,0,6.9-2,7.8-7.1l0.4-2.6c-2.2,2.4-5.4,4-8.9,4c-6,0-9.1-4.2-9.1-10.7c0-9.7,5-17.3,13.8-17.3c4.3,0,6.7,2.3,8,4.2l1-3.6l5.6,0   L143.4,43.4z M139.6,25.2c-0.7-1.2-2.7-3.2-5.4-3.2c-4.8,0-7.5,4.1-7.5,10.5c0,3.7,1.2,5.9,4.6,5.9c2.9,0,5.3-1.7,6.6-3L139.6,25.2   z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M157.7,44.2l-6.7,0l4.5-27.6l6.7,0L157.7,44.2z M160.7,6c2.1,0,3.6,1,3.6,3c0,2.6-2,4.1-4.7,4.1   c-2,0-3.5-1.1-3.5-3C156.1,7.5,158.3,6,160.7,6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M176.7,21.8l-2.6,15.5c-0.3,1.6,0.2,2.2,1.4,2.2c0.8,0,2.5-0.2,3.2-0.5l-0.1,4.8c-1.9,0.6-4.4,1.1-6.5,1.1   c-4,0-5.6-2.2-4.9-6.2l2.8-16.9l-3.6,0l0.7-4l3.8-1.2l2-7.9l5.9,0l-1.3,7.9l4.9,0l-0.8,5.2L176.7,21.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M202.8,40.6c-1.7,1.9-4.7,4.2-9,4.2c-6.2,0-9-4.2-9.1-11.1c0-11,6.4-17.8,14.1-17.8c3.4,0,6,1.2,7.7,4.1l1-3.5   l5.6,0l-4.5,27.6l-6,0L202.8,40.6z M205,25c-0.8-1.3-2.5-3.1-5.4-3.1c-4.5,0-7.6,4-7.6,10.8c0,3.5,0.8,6.3,4.5,6.3   c2.8,0,5.5-1.8,6.7-3.1L205,25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M216.2,44.1l6.2-37.6l6.8,0L223,44.1L216.2,44.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M248.5,6.5l12.7,0c7.3,0,10.5,2.7,10.5,7.6c0,4.3-2.6,9.3-8.2,10.2c-0.1,0.1-0.1,0.1-0.1,0.1   c5.3,0.6,7,4.3,7,7.6c0,9-6.9,12.2-16,12.2l-12.2,0L248.5,6.5z M247.8,39.8l8.7,0c6.1,0,9.3-3.3,9.3-8c0-3.8-3.1-5-7.5-4.9l-8.3,0   L247.8,39.8z M252.6,10.7l-2,11.9l6.6,0c5,0,9.5-1.6,9.4-7.4c0-3.3-2.5-4.5-6.7-4.5L252.6,10.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M290.7,16c6.5,0,10.3,3.9,10.4,10.9c0,1.1,0,2.2-0.3,3.4c-1.5,9.9-7.6,14.3-15,14.3c-6.7,0-10.3-3.8-10.4-10.8   c0-1,0.1-2.2,0.3-3.4C277.1,20.9,283.3,16,290.7,16z M280.3,33.5c0,4.9,2.3,7.1,6.3,7c4.4,0,8.3-3.2,9.4-10.2c0.2-1,0.3-2.1,0.3-3   c0-5.1-2.7-7.4-6.4-7.4c-4.4,0-8.1,3.3-9.3,10.2C280.4,31.4,280.3,32.6,280.3,33.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M314.2,30.1l-6.7-13.5l5,0l4.9,10.4l8.3-10.5l4.9,0l-11,13.5l6.8,13.9l-4.9,0l-5.1-10.9L307.6,44l-4.9,0   L314.2,30.1z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDigital);
export default __webpack_public_path__ + "static/media/logoDigital.f803869d5038e1416fc52a83f95cdaae.svg";
export { ForwardRef as ReactComponent };